import { Link } from 'react-router-dom';
import '../../styles/AboutSection.css'; // AboutSection ki CSS

function AboutSection() {
  return (
    <section className="abs-section-wrapper">
      <div className="abs-container">
        {/* Animated Background Elements */}
        <div className="abs-bg-circle abs-bg-circle-1"></div>
        <div className="abs-bg-circle abs-bg-circle-2"></div>
        <div className="abs-bg-circle abs-bg-circle-3"></div>

        {/* Section Header */}
        <div className="abs-header-wrapper">
          <span className="abs-section-badge">
            <span className="abs-badge-dot"></span>
            About Us
          </span>
          <h2 className="abs-title">
            Where <span className="abs-title-highlight">Champions</span> Are Made
          </h2>
          <p className="abs-subtitle">
            India's premier platform connecting athletes, teams, and sports enthusiasts
            through seamless event discovery and registration
          </p>
        </div>

        {/* Stats Row */}
        <div className="abs-stats-row">
          <div className="abs-stat-card">
            <span className="abs-stat-number">50+</span>
            <span className="abs-stat-label">Events Hosted</span>
            <span className="abs-stat-icon">🏆</span>
          </div>
          <div className="abs-stat-card">
            <span className="abs-stat-number">200+</span>
            <span className="abs-stat-label">Teams Registered</span>
            <span className="abs-stat-icon">👥</span>
          </div>
          <div className="abs-stat-card">
            <span className="abs-stat-number">10+</span>
            <span className="abs-stat-label">Sports Categories</span>
            <span className="abs-stat-icon">🏅</span>
          </div>
          <div className="abs-stat-card">
            <span className="abs-stat-number">98%</span>
            <span className="abs-stat-label">Satisfaction Rate</span>
            <span className="abs-stat-icon">⭐</span>
          </div>
        </div>

        {/* Main Content - Story & Features */}
        <div className="abs-content-wrapper">
          {/* Left Side - Story */}
          <div className="abs-story-wrapper glass-effect">
            <div className="abs-story-tag">Our Story</div>
            <span className="abs-story-icon">🚀</span>
            <h3>Born from a <span className="abs-highlight-text">Simple Idea</span></h3>
            <p>
              VernaEvents was founded in 2024 with a singular vision: 
              <strong> to democratize sports event access for everyone.</strong> 
              What started as a small community initiative has now grown into 
              India's trusted sports event platform.
            </p>
            <p>
              We believe that <strong>every athlete deserves a stage</strong> to showcase their talent. 
              Whether you're a professional team chasing glory or a group of friends 
              playing for fun, VernaEvents is your gateway to the world of competitive sports.
            </p>
            <div className="abs-story-timeline">
              <div className="abs-timeline-item">
                <span className="abs-timeline-year">2024</span>
                <span className="abs-timeline-text">Founded with a vision</span>
              </div>
              <div className="abs-timeline-item">
                <span className="abs-timeline-year">2025</span>
                <span className="abs-timeline-text">50+ events hosted</span>
              </div>
              <div className="abs-timeline-item">
                <span className="abs-timeline-year">2026</span>
                <span className="abs-timeline-text">200+ teams & growing</span>
              </div>
            </div>
            <Link to="/about" className="abs-story-btn">
              Read Full Story →
            </Link>
          </div>

          {/* Right Side - Features */}
          <div className="abs-features-wrapper glass-effect">
            <div className="abs-features-tag">Why Us</div>
            <h3>Built for <span className="abs-highlight-text">Excellence</span></h3>
            <div className="abs-features-grid">
              <div className="abs-feature-card">
                <div className="abs-feature-icon-wrapper">
                  <span className="abs-feature-icon">🔍</span>
                </div>
                <div>
                  <h4>Smart Discovery</h4>
                  <p>AI-powered event recommendations tailored to your sport</p>
                </div>
              </div>
              <div className="abs-feature-card">
                <div className="abs-feature-icon-wrapper">
                  <span className="abs-feature-icon">⚡</span>
                </div>
                <div>
                  <h4>Instant Registration</h4>
                  <p>Register your team in under 2 minutes with zero hassle</p>
                </div>
              </div>
              <div className="abs-feature-card">
                <div className="abs-feature-icon-wrapper">
                  <span className="abs-feature-icon">🛡️</span>
                </div>
                <div>
                  <h4>Secure & Trusted</h4>
                  <p>Protected payments and transparent booking process</p>
                </div>
              </div>
              <div className="abs-feature-card">
                <div className="abs-feature-icon-wrapper">
                  <span className="abs-feature-icon">🎯</span>
                </div>
                <div>
                  <h4>Competitive Edge</h4>
                  <p>Track performance, rankings, and team stats in real-time</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mission & Vision - Modern Cards */}
        <div className="abs-mission-wrapper">
          <div className="abs-mission-card abs-mission-card-left">
            <div className="abs-mission-icon-wrapper">
              <span className="abs-mission-icon">🎯</span>
            </div>
            <h3>Our Mission</h3>
            <p>
              To empower every athlete by providing a seamless, accessible platform 
              for discovering, registering, and excelling in sports events across India.
            </p>
            <div className="abs-mission-line"></div>
          </div>
          <div className="abs-mission-card abs-mission-card-right">
            <div className="abs-mission-icon-wrapper">
              <span className="abs-mission-icon">🌟</span>
            </div>
            <h3>Our Vision</h3>
            <p>
              To build India's largest sports ecosystem where talent meets opportunity, 
              fostering a vibrant community of athletes and sports enthusiasts.
            </p>
            <div className="abs-mission-line"></div>
          </div>
        </div>

        {/* Modern Bottom CTA */}
        <div className="abs-bottom-cta">
          <div className="abs-bottom-content">
            <div className="abs-bottom-left">
              <span className="abs-bottom-icon">💪</span>
              <div>
                <h4>Join the <span className="abs-bottom-highlight">Revolution</span></h4>
                <p>Be part of India's fastest growing sports community</p>
              </div>
            </div>
            <div className="abs-bottom-right">
              <Link to="/events" className="abs-bottom-btn">
                Get Started
                <svg className="abs-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
              <Link to="/about" className="abs-bottom-btn-secondary">
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;